import { createContext, useContext, useRef, useMemo } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import { udpateTest, addTest, getTestById } from "../../api/testimonial";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const AddWorkArray = useRef();
  const toaster = useToaster();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const page = searchParams.get("page")
  const navigate = useNavigate();

  const getWorkQuery = useQuery({
    queryKey: [{ id }],
    queryFn: getTestById,
    enabled: !!id,
  });

  const updateWorkQuery = useMutation({ mutationFn: udpateTest });
  const addWorkItemQuery = useMutation({ mutationFn: addTest });

  const initialValues = useMemo(() => {
    const [workAddData] = getWorkQuery?.data?.data?.data || [];
    return {
      name: workAddData?.name || "",
      position: workAddData?.position || "",
      description: workAddData?.description || "",
      rating: workAddData?.rating,
      user_image: workAddData?.user_image,
      alt_tag : workAddData?.alt_tag || "",
    };
  }, [getWorkQuery]);

  const handleSubmit = async (values) => {
    const payload = {
      name: values?.name,
      position: values?.position,
      description: values?.description,
      rating: values?.rating,
      user_image: values?.user_image,
      alt_tag:values?.alt_tag,
      page: page
    };

    if (id) {
      payload.id = id
      updateWorkQuery.mutate(payload, {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
        },
      });
      return;
    }
    addWorkItemQuery.mutate(payload, {
      onSuccess: () => {
        navigate(-1)
        toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_ADDED_SUCCESSFULLY);
      },
    });
  };

  const handleNewWorkAdd = () => {
    AddWorkArray.current.push({ image_link: "" });
  };

  const handleNewWorkDelete = (index) => () => {
    AddWorkArray.current.remove(index);
  };
  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleNewWorkDelete,
        AddWorkArray,
        handleNewWorkAdd,
        getWorkQuery,
        handleSubmit,
        id,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const useAddWorkProvider = () => {
  return useContext(PageContext);
};
